import { render, staticRenderFns } from "./AccountAssistants.vue?vue&type=template&id=5bcbed64&scoped=true"
import script from "./AccountAssistants.vue?vue&type=script&lang=js"
export * from "./AccountAssistants.vue?vue&type=script&lang=js"
import style0 from "./AccountAssistants.vue?vue&type=style&index=0&id=5bcbed64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbed64",
  null
  
)

export default component.exports